/**
 * Debugger
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @lastModified 2024-11-28 Created the Debugger.
 * @package felixkiesewetter-js/consentmanager
 * @since 5.0.0
 */
class Debugger
{

    #enabled = true;
    #identifier;
    #style = 'background: #222; color: #bada55; padding: 4px;'; // TODO: Option/argument to set style

    constructor(identifier = 'Debugger', enable = true)
    {
        this.#identifier = identifier.trim();
        enable && this.enable();
    }

    log(...parameters)
    {
        this.dump('log', ...parameters);
    }

    error(...parameters)
    {
        this.dump('error', ...parameters);
    }

    warn(...parameters)
    {
        this.dump('warn', ...parameters);
    }

    dump(type = 'log', ...parameters) {
        const stackLines = (new Error()).stack.split("\n");
        const callerLine = stackLines[3]?.trim();
        const callerLineParts = callerLine.split(' ');
        const callerFunction = callerLineParts[1] + '()';
        this.#enabled && console[type](
            `%c${this.#identifier}`,
            this.#style,
            callerFunction,
            ...parameters
        );
    }

    enable()
    {
        this.#enabled = true;
        return this;
    }

    disable()
    {
        this.#enabled = false;
        return this;
    }

    setIdentifier(identifier)
    {
        this.#identifier = identifier;
        return this;
    }

}

export default Debugger;